// Pure helpers for the Repeated findings page: state labels and the filter pills.
export const STATE = {
  came_back: { label: 'Came back after fixed', color: '#ef4444' },
  open: { label: 'Still open', color: '#f59e0b' },
  fixed: { label: 'Fixed', color: '#22c55e' }
};

export const FILTERS = [
  { id: 'all', label: 'All', test: () => true },
  { id: 'came_back', label: 'Came back', test: (r) => r.state === 'came_back' },
  { id: 'urgent', label: 'Critical and high', test: (r) => r.severity === 'critical' || r.severity === 'high' }
];

export function visible(rows, filter, q = '') {
  const f = FILTERS.find((x) => x.id === filter) || FILTERS[0];
  const needle = q.trim().toLowerCase();
  return rows.filter((r) => f.test(r) && (!needle || `${r.title} ${r.website}`.toLowerCase().includes(needle)));
}

export const scansLine = (r) => {
  const total = r.timeline.length;
  const hits = r.timeline.filter(Boolean).length;
  if (r.state === 'fixed') return `Found in ${r.scans} scan${r.scans === 1 ? '' : 's'}, not seen in the latest`;
  return total >= 2 && r.scans >= hits ? `Found in ${hits} of the last ${total} scans` : `Found in ${r.scans} scan${r.scans === 1 ? '' : 's'}`;
};
